import { Link } from 'react-router-dom';
import { NotepadText, Pin } from 'lucide-react';
import TrCourseImg from '../../../assets/images/TrainingCoursesImg.png';

const PlanLoading = ({ course }) => {
  return (
    <Link to={`/training-courses/${course?.id}`} className="relative pt-7 pb-3 px-3 grid grid-cols-[28%_72%] border rounded-lg w-[27rem] max-lg:w-full max-lg:grid-cols-1">
      <div className="relative w-32 bg-transparent max-lg:h-18">
        <div className="w-[7.5rem] h-[7.5rem] flex justify-center items-center absolute -top-14 -right-5 max-md:relative max-lg:h-28 max-lg:w-48 max-lg:relative">
          <div className="bg-secondary-tw w-[7.8rem] h-[7.8rem] max-lg:h-[7.4rem] max-lg:w-[12.4rem] absolute z-0 rounded-lg"></div>
          <img
            src={course?.course?.image || TrCourseImg}
            alt={course?.title || 'course-title'}
            className="object-cover w-full relative z-10 h-full rounded-lg"
          />
        </div>
      </div>

      <div className="flex flex-col justify-between">
        <div className="!text-start">
          <p className="text-[var(--primary-color)] no-pm" style={{ fontSize: '18px' }}>
            {course?.course?.title || 'عنوان الكورس التدريبي'}
          </p>

          <div className="flex items-center gap-2">
            <span>
              <Pin fill="#7A7A7A" size={16} color="#7A7A7A" />
            </span>
            <p className="no-pm text-[var(--semi-gray)]" style={{ fontSize: '13px' }}>
              {course?.category?.title || 'فئة الكورس التدريبي'}
            </p>
          </div>

          <div className="flex items-center gap-2">
            <span>
              <NotepadText fill="white" size={16} color="#7A7A7A" />
            </span>

          </div>
        </div>

        <div className="flex items-center justify-end gap-2 mt-2 flex-wrap max-lg:items-start">
          <p className="no-pm text-[var(--semi-gray)]" style={{ fontSize: '14px' }}>
            السعر يبدأ من:
          </p>
          <p className="no-pm bg-primary-tw flex items-center gap-1 text-white px-3 rounded-lg" style={{ fontSize: '14px' }}>
            <span>
              {course?.course?.min_price || '0'} {/* Default to 0 if no price is available */}
            </span>
            <span>﷼</span>
          </p>
        </div>
      </div>
    </Link>
  );
};

export default PlanLoading;
